import React from "react";

import ServiceListItem from "./ServicesListItem";

export default (props) => {
  const { show, services } = props.input;

  return (
    <>
      {show && (
        <section className="services-list wrapper">
          {(services || [])
            .filter((item) => item && item.service)
            .map(({ service }, index) => (
              <ServiceListItem service={service} index={index} key={index} />
            ))}
        </section>
      )}
    </>
  );
};
